import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/drywall-calculator',
  component: () => import('../../routes/DrywallCalculator.svelte'),
  card: {
    id: 'drywall-calculator',
    title: 'Drywall Calculator',
    description:
      'Calculate drywall sheets, joint compound, tape, screws, and corner bead needed for any room. Supports 4×8, 4×10, 4×12, and 4×14 sheets with optional ceiling drywall and adjustable waste factor.',
    icon: 'grid_view',
    iconBgClass: 'bg-stone-50',
    iconTextClass: 'text-stone-600',
    href: '/drywall-calculator',
    category: 'Real Estate',
  },
  seo: {
    title:
      'Drywall Calculator – Sheets, Joint Compound, Screws, Tape, Corner Bead',
    description:
      'Free drywall calculator. Estimate the number of 4×8, 4×10, 4×12, or 4×14 drywall sheets plus joint compound (50 sqft/gal), paper tape (350 ft/roll), screws (200 sqft/lb), and metal corner bead needed for any room. Includes walls, optional ceiling, doors/windows, and waste factor.',
  },
};

export default meta;
